import styled from "styled-components/macro";

export const StandbyBox = styled.div`
  width: 100%;
  height: 101.9%;
  position: absolute;
  top: -1%;
  left: 0%;
  background: #337fbf;
  border: none;
  /* display: flex; */
  /* justify-content: space-around; */
  /* flex-direction: column; */
  text-align: center;
  color: white;
`;

export const StandbyLogoContainer = styled.div`
  margin-top: 3rem;
  margin-bottom: 2rem;
  /* height: 90px; */
  height: 90px;
  width: auto;
`;
export const StandbyLogo = styled.img`
  /* filter: invert(100%); */
  object-fit: contain;
`;

export const StandbyTitle = styled.h1``;

export const StandbyText = styled.p`
  @media screen and (max-width: 390px) {
    /* gap: 0; */
    /* max-height: 130px; */
    /* margin-top: .5rem; */
    font-size: 0.7rem;
  }
`;
